/* eslint-disable @typescript-eslint/ban-types */
import { WidgetBase } from '@dojo/framework/core/WidgetBase';
import { ThemedMixin } from '@dojo/framework/core/mixins/Themed';
import { I18nMixin } from '@dojo/framework/core/mixins/I18n';
import { Constructor } from '@dojo/framework/core/interfaces';

// tslint:disable-next-line:variable-name
export const Themed: Constructor<ThemedMixin<{}>> & typeof WidgetBase = ThemedMixin(WidgetBase);
// tslint:disable-next-line:variable-name
export const I18nThemed: Constructor<ThemedMixin<{}>> & typeof WidgetBase & Constructor<I18nMixin> = I18nMixin(
	ThemedMixin(WidgetBase)
);
